import axios from 'axios';

const getAuthHeader = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
});

export const fetchPorts = async () => {
  const response = await axios.get('/api/admin/ports/', getAuthHeader());
  return response.data;
};

export const deletePort = async (id) => {
  await axios.delete(`/api/admin/ports/${id}/`, getAuthHeader());
};
